<template>
  <div>
    <!-- 孩子信息 -->
    <ChildInfo
      :choice_open.sync="choice_open"
      :info="info"
      @Refresh="WaterGetDrinkInfo"
    />
    <!-- 饮水量 -->
    <DrinkVolume :info="info" @openPdf="loadPDF" />
    <!-- 温馨提示 -->
    <div class="tips-content" :style="desc_style">温馨提醒：{{info.drink_string}}</div>
    <!-- tab -->
    <TabbarCartoon :list="tab_list" v-model="tab_index" />
    <!-- 日 -->
    <DayData v-show="tab_index === 0" />
    <!-- 周 -->
    <WeekData v-if="tab_index === 1" />
    <!-- 月 -->
    <MonthData v-if="tab_index === 2" />
    <!-- 添加类型选择 -->
    <van-popup v-model="choice_open" position="bottom" :style="{ borderRadius: '.16rem .16rem 0 0' }">
      <ModelChoice :edit="$route.query.id" />
    </van-popup>
    <PDF ref="pdf" v-show="show"/>
  </div>
</template>

<script>
  import ChildInfo from './components/ChildInfo'
  import DrinkVolume from './components/DrinkVolume'
  import DayData from './components/DayData'
  import WeekData from './components/WeekData'
  import MonthData from './components/MonthData'
  export default {
    data () {
      return {
        tab_list: [
          { title: '日' },
          { title: '周' },
          { title: '月' }
        ],
        tab_index: 0,
        choice_open: false,
        info: {},
        pSrc: '',
        show: false
      }
    },
    methods: {
      WaterGetDrinkInfo () {
        this.$Get('Common.WaterGetDrinkInfo', {
          cup_id: this.$route.query.id
        }).then(res => {
          this.info = res.data
        })
      },
      loadPDF (pdf) {
        console.log(pdf)
        const Pdf = this.$refs['pdf']
        Pdf.showPDF(pdf)
        this.show = true
      }
    },
    created () {
      this.WaterGetDrinkInfo()
    },
    computed: {
      desc_style () {
        if (this.info.drink_percent * 1 >= 100) {
          return `color: #00d6c1`
        }
        return ''
      }
    },
    components: {
      ChildInfo,
      DrinkVolume,
      DayData,
      WeekData,
      MonthData
    }
  }
</script>

<style lang="less" scoped>
  .tips-content {
    text-align: center;
    .fz(.28rem);
    .c(#999);
    .mb(.95rem);
  }
  .wrap{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
  }
</style>
